"use strict";

var _createForOfIteratorHelper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _wrapNativeSuper = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var modules_1 = require("./modules");

var SdkError = /*#__PURE__*/function (_Error) {
  _inherits(SdkError, _Error);

  var _super = _createSuper(SdkError);

  function SdkError() {
    var _this;

    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SdkError.Types.Internal;
    var data = arguments.length > 2 ? arguments[2] : undefined;
    var origin = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, SdkError);

    _this = _super.call(this, message);
    _this.type = type;
    _this.data = data;
    _this.origin = origin;
    return _this;
  }

  _createClass(SdkError, [{
    key: "toRawObject",
    value: function toRawObject() {
      return {
        message: this.message,
        type: this.type,
        data: this.data || null
      };
    }
  }], [{
    key: "attachTo",
    value: function attachTo(methodsNames, obj) {
      var _this2 = this;

      var _iterator = _createForOfIteratorHelper(methodsNames),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var methodsName = _step.value;

          if (methodsName !== 'constructor') {
            (function () {
              var method = obj[methodsName].bind(obj);

              obj[methodsName] = function () {
                var result;

                try {
                  var promise = method.apply(void 0, arguments);

                  if (promise instanceof Promise) {
                    result = promise.catch(function (error) {
                      return _this2.throwFromAny(error);
                    });
                  } else {
                    result = promise;
                  }
                } catch (err) {
                  _this2.throwFromAny(err);
                }

                return result;
              };
            })();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "isSdkError",
    value: function isSdkError(err) {
      return typeof err === 'object' && err && err instanceof this;
    }
  }, {
    key: "isSdkApiError",
    value: function isSdkApiError(err) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return this.isSdkError(err) && modules_1.ApiError.isApiError(err.origin, type);
    }
  }, {
    key: "fromAny",
    value: function fromAny(err) {
      var result = null;

      switch (typeof err) {
        case 'string':
          result = new SdkError(err);
          break;

        case 'object':
          if (err instanceof SdkError) {
            result = err;
          } else if (modules_1.ApiError.isApiError(err)) {
            var error = err.error,
                errors = err.errors,
                message = err.message;
            result = new SdkError(error || message, SdkError.Types.Http, errors, err);
          } else if (modules_1.EthError.isEthError(err)) {
            var _message = err.message;
            result = new SdkError(_message, SdkError.Types.EthNode);
          } else if (err instanceof Error) {
            var _message2 = err.message;
            result = new SdkError(_message2, SdkError.Types.Internal, undefined, err);
          }

      }

      return result;
    }
  }, {
    key: "throwFromAny",
    value: function throwFromAny(err) {
      throw this.fromAny(err);
    }
  }, {
    key: "throwEthTransactionReverted",
    value: function throwEthTransactionReverted(data) {
      throw new SdkError('reverted', SdkError.Types.EthTransaction, data);
    }
  }]);

  return SdkError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.SdkError = SdkError;

(function (SdkError) {
  var Types;

  (function (Types) {
    Types["Internal"] = "Internal";
    Types["Http"] = "Http";
    Types["EthNode"] = "EthNode";
    Types["EthTransaction"] = "EthTransaction";
  })(Types = SdkError.Types || (SdkError.Types = {}));
})(SdkError = exports.SdkError || (exports.SdkError = {}));